import React from 'react';

export default function StatusSelect({ selectedStatus, onStatusChange, dateUpdate }) {
  return (
    <div className="status-select-wrapper">
      <select
        className="clean-select"
        value={selectedStatus}
        onChange={onStatusChange}
      >
        <option value="">Sélectionner</option>
        <option value="1">Nouvelles</option>
        <option value="2">Relances</option>
        <option value="6">Envoyés</option>
        <option value="4">Réalisés</option>
        <option value="5">Abandons</option>
      </select>

      {dateUpdate && (
        <span
          style={{
            fontSize: "12px",
            color: "#6b7280",
            marginLeft: "auto",
            whiteSpace: "nowrap",
          }}
        >
          modifié le : {dateUpdate}
        </span>
      )}
    </div>
  );
}